import VeeValidate, { Validator } from 'vee-validate'
import validateTw from '../i18n/validate/zh-TW'
import validateEn from '../i18n/validate/en'
import validateEvents from '../events/validateEvents'

const veeValidatePlugin = {
  install (Vue, options) {
    Validator.localize('zh-TW', validateTw)
    Validator.localize('en', validateEn)
    Validator.extend('customNumeric', validateEvents.customNumeric)
    Validator.extend('customVerifyAfterDate', validateEvents.customVerifyAfterDate)
    Validator.extend('no_space', validateEvents.no_space)
    Validator.extend('customTime', validateEvents.customTime)
    Validator.extend('mobileTaiwan', validateEvents.mobileTaiwan)
    Validator.extend('customStrLen', validateEvents.customStrLen)
    Validator.extend('checkDateRepeat', validateEvents.checkDateRepeat)
    Validator.extend('minArrLen', validateEvents.minArrLen)
    Validator.extend('maxArrLen', validateEvents.maxArrLen)
    Validator.extend('validateHttpsUrl', validateEvents.validateHttpsUrl)
    Validator.extend('phoneCode', validateEvents.phoneCode)
    Validator.extend('naturalCode', validateEvents.naturalCode)
    Validator.extend('loveCode', validateEvents.loveCode)
    Validator.extend('taxNumber', validateEvents.taxNumber)
    Validator.extend('customPhoneNum', validateEvents.customPhoneNum)
    Validator.extend('customEmail', validateEvents.customEmail)
    Validator.extend('brand', validateEvents.brand)
    Validator.extend('customPassword', validateEvents.customPassword)
    Validator.extend('customPasswordLen', validateEvents.customPasswordLen)
    Vue.use(VeeValidate, {
      locale: 'zh-TW'
    })
  }
}

export default veeValidatePlugin
